import classNames from "classnames";
import React, {useState} from "react";
import { parseISO } from "date-fns";

import '../style.css'
import ListDetails from "./ListDetails";
import ListDetailsActions from "./ListDetailsActions";
import {useTranslation} from "react-i18next";
import useInterval from "../../../utils/useInterval";
import {ORDER_STATUS, ORDER_TYPE_DINEIN, ORDER_TYPE_PICKUP} from "../../../store/Orders/reducer";

const TimeSpend = ({confirmed_at}) => {
    const [timeSpent, setTimeSpent] = useState(0)
    const [days, setDays] = useState(0)
    const [hours, setHours] = useState('00')
    const [minutes, setMinutes] = useState('00')
    const [seconds, setSeconds] = useState('00')
    const [delay, setDelay] = useState(1000);
    const [isRunning, setIsRunning] = useState(true);
    if (!confirmed_at) return null

    let confirmDate = parseISO(confirmed_at).getTime()

    useInterval(()=> {
        let now = new Date().getTime()
        setTimeSpent(now - confirmDate)

        let days = Math.floor(timeSpent / (1000 * 60 * 60 * 24));
        let hours = Math.floor((timeSpent % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); hours = hours < 10 ? '0' + hours : hours
        let minutes = Math.floor((timeSpent % (1000 * 60 * 60)) / (1000 * 60)); minutes = minutes < 10 ? '0' + minutes : minutes
        let seconds = Math.floor((timeSpent % (1000 * 60)) / 1000); seconds = seconds < 10 ? '0'+seconds : seconds

        // Calculating the days, hours, minutes and seconds left
        setDays(days)
        setHours(hours);
        setMinutes(minutes);
        setSeconds(seconds);

    }, isRunning ? delay : null)

    return (
        <span>
            {hours}:{minutes}:{seconds}
        </span>
    )

}

const ListOrders = ({ orders, order }) => {
    const { t } = useTranslation()

    let tables = []
    let idx = 0
    let tablesIds = {};
    orders.map((order) => {
        if (!tablesIds[order.table_session_id]) {
            tablesIds[order.table_session_id] = ++idx;
            tables[idx] = {
                id: order.table_session_id,
                confirmed_at: order.confirmed_at,
                pickup_at: order.pickupAt,
                type: order.type,
                table_code: order.table_code,
                status: order.status,
                order_id: order.id,
                buttons: order.buttons,
                orders: []
            }
        }
        tables[tablesIds[order.table_session_id]]['orders'].push(order)
    })

    return (
        <div className="grid grid-cols-3 bg-white">

            {tables.map((table) => {
                let classname = classNames("item shadow rounded-md m-2 grid grid-rows-3", {
                    "bg-indigo-100": table.id === order.table_session_id
                });
                return (
                    <div className={classname} key={table.id}
                    style={{gridTemplateRows: 'auto 1fr auto',
                        gridTemplateColumns: '100%'}}>
                        <div className="bg-gray-200 rounded-t-md text-center text-xl py-2">
                            {table.type === ORDER_TYPE_PICKUP && table.pickup_at ? (
                                <div className="font-bold ">Pickup at {table.pickup_at}</div>
                            ) :null}

                            {table.type === ORDER_TYPE_DINEIN && table.table_code ? (
                                <div className="font-bold">Table {table.table_code}</div>
                            ) :null}
                            <div className="text-sm text-indigo-600">Status: {table.status}</div>

                            {table.status === ORDER_STATUS ? (
                                <TimeSpend confirmed_at={table.confirmed_at} />
                            ):null}


                        </div>

                        <ListDetails orders={table.orders} />
                        <ListDetailsActions order_id={table.order_id} buttons={table?.buttons} />

                    </div>
                )
            })}

            {!orders.length ? (
                <div className="item shadow sm:rounded-lg px-4 py-2 m-2 col-span-3 text-center">
                    <span className="font-bold">{t('No active orders')}</span>
                </div>
            ): null}
        </div>
    )
}

export default ListOrders
